<template>
  <div>
    <h1>About</h1>
    <div class="description text-secondary mb-3">
      Teonet single page application description.
    </div>
    <TeoInfo />
    <VueInfo />
    <ButstrapInfo />
  </div>
</template>

<script>
import TeoInfo from "../TeoInfo.vue";
import VueInfo from "../VueInfo.vue";
import ButstrapInfo from "../BootstrapInfo.vue";

export default {
  name: "App",
  components: {
    TeoInfo,
    VueInfo,
    ButstrapInfo,
  },
};
</script>

<style>
a {
  text-decoration: none !important;
}
h3 {
  margin-bottom: 15px !important;
}
</style>
